module.exports = __webpack_public_path__ + "media/images/voting_4-8c518233aa285c2932aed88b6d46405e.svg";